<template>
  <div class="fix" @scroll="onScroll" ref="scrollableDiv">
    <div v-for="comment in comments" :key="comment.id" class="message-container d-flex" :class="comment.isCurrentUserComment ? '' : 'flex-row-reverse'">
      <div class="" :class="comment.isCurrentUserComment ? 'me-2' : 'ms-2'">
        <img class="rounded-circle" v-if="comment.imageUrl !== '' && comment.imageUrl !== null" :src="comment.imageUrl" width="41" height="41" />
        <img class="rounded-circle" v-else src="@/assets/images/users/default.png" width="41" height="41" />
      </div>
      <div class="content-container w-100">
        <div class="message-content">
          <div class="header-content" :class="comment.isCurrentUserComment ? '' : 'flex-row-reverse'">
            <div class="name">{{ comment.name }}</div>
            <div class="message-time">{{ convertTime(comment.dateTime) }}</div>
          </div>
          <p>{{ comment.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comment-container',
  props: {
    comments: {
      type: Array,
      default: null,
    },
    goUp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hover: false,
    }
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.$emit('needUpdate')
      }
    },
  },
  watch: {
    goUp(val) {
      if (val === true) {
        this.$refs.scrollableDiv.scrollTop = 0
      }
    },
  },
  mounted() {},
}
</script>

<style scoped lang="scss">
@import '../../design/custom/components/_comment.scss';
.hover-parent {
  position: relative;
}
.hover-child {
  position: absolute;
  top: -20px;
  width: 300px;
  word-wrap: break-word;
  right: 50%;
  transform: translateX(50%);
  text-align: center;
  background-color: rgb(235, 235, 235);
  padding: 10px;
  border-radius: 5px;
}
</style>
